module.exports = __webpack_public_path__ + "static/headshot-small-fcac5003dc37b130f4bb4fa54612ec01.jpg";